import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./galleryDetail.module.css";
import ShadcnButton from "../../../../../components/button/ShadcnButton";
import { getLocationOrigin } from "../../../../../services";
import { getCDNUrl } from "../../../../../utils/getCDNUrl";

function ArrowLeft() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

function Download() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}

function Trash2(props) {
  var color = props.color || "currentColor";
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  );
}

function Plus() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function Calendar() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function MapPin() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function Trophy() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 6 2 18 2 18 9" />
      <path d="M6 9a6 6 0 0 0 12 0" />
      <line x1="12" y1="15" x2="12" y2="19" />
      <line x1="8" y1="19" x2="16" y2="19" />
      <path d="M6 2H3a1 1 0 0 0-1 1v2a4 4 0 0 0 4 4" />
      <path d="M18 2h3a1 1 0 0 1 1 1v2a4 4 0 0 1-4 4" />
    </svg>
  );
}

function ChevronLeft() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

function ChevronRight() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function Maximize() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" y1="3" x2="14" y2="10" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

class Lightbox extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e) {
    if (!this.props.open) return;
    if (e.key === "Escape") this.props.onClose();
    if (e.key === "ArrowLeft") this.props.onPrev();
    if (e.key === "ArrowRight") this.props.onNext();
  }

  render() {
    var isOpen = this.props.open;
    var photos = this.props.photos;
    var currentIndex = this.props.currentIndex;
    var onClose = this.props.onClose;
    var onPrev = this.props.onPrev;
    var onNext = this.props.onNext;

    if (!isOpen || !photos || photos.length === 0 || currentIndex === null) return null;

    var currentPhoto = photos[currentIndex];

    return (
      <div className="lightbox-backdrop" onClick={onClose}>
        <div className="lightbox-topbar" onClick={function(e) { e.stopPropagation(); }}>
          <div className="lightbox-counter">
            {currentIndex + 1} / {photos.length}
          </div>
          <button className="lightbox-btn lightbox-btn--close" onClick={onClose} aria-label="Close lightbox">
            <XIcon />
          </button>
        </div>

        <div className="lightbox-content" onClick={onClose}>
          <img 
            className="lightbox-image" 
            src={getCDNUrl(currentPhoto.image)} 
            alt={"Photo " + currentPhoto.id} 
            onClick={function(e) { e.stopPropagation(); }}
          />

          {photos.length > 1 && (
            <div onClick={function(e) { e.stopPropagation(); }}>
              <button 
                className="lightbox-btn lightbox-btn--nav lightbox-btn--prev" 
                onClick={onPrev}
                aria-label="Previous photo"
              >
                <ChevronLeft />
              </button>
              <button 
                className="lightbox-btn lightbox-btn--nav lightbox-btn--next" 
                onClick={onNext}
                aria-label="Next photo"
              >
                <ChevronRight />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function ConfirmModal(props) {
  var open         = props.open;
  var title        = props.title;
  var children     = props.children;
  var onCancel     = props.onCancel;
  var onConfirm    = props.onConfirm;
  var confirmLabel = props.confirmLabel || "Confirm";
  var loading      = props.loading || false;
  var destructive  = props.destructive !== false;

  if (!open) return null;

  var confirmBg = destructive ? "#dc2626" : "#2563eb";

  return (
    <div
      onClick={loading ? null : onCancel}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.45)", backdropFilter: "blur(2px)",
        display: "flex", alignItems: "center", justifyContent: "center", padding: "16px",
      }}
    >
      <div
        onClick={function (e) { e.stopPropagation(); }}
        role="dialog" aria-modal="true" aria-labelledby="modal-title"
        style={{
          background: "#fff", borderRadius: "12px",
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.08), 0 20px 40px -8px rgba(0,0,0,0.18)",
          width: "100%", maxWidth: "420px", overflow: "hidden",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 20px 0" }}>
          <h2 id="modal-title" style={{ fontSize: "15px", fontWeight: 600, color: "#111827", margin: 0, lineHeight: 1.4 }}>
            {title}
          </h2>
          <button
            onClick={onCancel} disabled={loading} aria-label="Close"
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "28px", height: "28px", border: "none", background: "none",
              borderRadius: "6px", color: "#9ca3af",
              cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.4 : 1,
              flexShrink: 0, padding: 0,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div style={{ padding: "12px 20px 20px", fontSize: "14px", color: "#4b5563", lineHeight: 1.6 }}>
          {children}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", padding: "12px 20px 20px", borderTop: "1px solid #f3f4f6" }}>
          <button
            onClick={onCancel} disabled={loading}
            style={{
              display: "inline-flex", alignItems: "center", gap: "6px",
              padding: "7px 14px", borderRadius: "7px", fontSize: "13px", fontWeight: 500,
              cursor: loading ? "not-allowed" : "pointer",
              border: "1px solid #e5e7eb", background: "#fff", color: "#374151",
              opacity: loading ? 0.55 : 1, lineHeight: 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm} disabled={loading}
            style={{
              display: "inline-flex", alignItems: "center", gap: "6px",
              padding: "7px 14px", borderRadius: "7px", fontSize: "13px", fontWeight: 500,
              cursor: loading ? "not-allowed" : "pointer",
              border: "1px solid transparent", background: confirmBg, color: "#fff",
              opacity: loading ? 0.55 : 1, lineHeight: 1,
            }}
          >
            {loading && (
              <span style={{
                display: "inline-block", width: "12px", height: "12px",
                border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff",
                borderRadius: "50%", animation: "modal-spin 0.6s linear infinite",
              }} />
            )}
            {confirmLabel}
          </button>
        </div>
      </div>
      <style>{`@keyframes modal-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

class AlbumDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      album:               null,
      loading:             true,
      error:               null,
      selectedPhotos:      [],
      showDeleteDialog:    false,
      showDeleteAlbumDialog: false,
      downloading:         false,
      deletingAlbum:       false,
      deletingPhotos:      false,  // loading state for photo delete
      deleteError:         null,   // per-operation error message
      lightboxIndex:       null,
    };

    this.togglePhotoSelection  = this.togglePhotoSelection.bind(this);
    this.openLightbox          = this.openLightbox.bind(this);
    this.closeLightbox         = this.closeLightbox.bind(this);
    this.handlePrevLightbox    = this.handlePrevLightbox.bind(this);
    this.handleNextLightbox    = this.handleNextLightbox.bind(this);
    this.handleDeletePhotos    = this.handleDeletePhotos.bind(this);
    this.handleDeleteAlbum     = this.handleDeleteAlbum.bind(this);
    this.handleDownloadPhotos  = this.handleDownloadPhotos.bind(this);
  }

  componentDidMount() {
    var albumId = this.props.match.params.albumId;
    this.fetchAlbum(albumId);
  }

  fetchAlbum(albumId) {
    var self = this;
    self.setState({ loading: true, error: null });

    fetch(getLocationOrigin() + "/gallery/get_albums_by_id/?album_id=" + albumId)
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to fetch album (HTTP " + response.status + ")");
        return response.json();
      })
      .then(function (data) {
        if (!data.success) {
          self.setState({ error: data.message || "Album not found.", loading: false });
          return;
        }
        self.setState({ album: data.album, loading: false });
      })
      .catch(function (err) {
        console.error("fetchAlbum error:", err);
        self.setState({ error: "Something went wrong. Please try again.", loading: false });
      });
  }

  openLightbox(index) {
    this.setState({ lightboxIndex: index });
  }

  closeLightbox() {
    this.setState({ lightboxIndex: null });
  }

  handlePrevLightbox() {
    this.setState(function (prevState) {
      if (!prevState.album || !prevState.album.photos) return null;
      var len = prevState.album.photos.length;
      return { lightboxIndex: (prevState.lightboxIndex + len - 1) % len };
    });
  }

  handleNextLightbox() {
    this.setState(function (prevState) {
      if (!prevState.album || !prevState.album.photos) return null;
      var len = prevState.album.photos.length;
      return { lightboxIndex: (prevState.lightboxIndex + 1) % len };
    });
  }

  togglePhotoSelection(photoId) {
    this.setState(function (prevState) {
      return {
        selectedPhotos: prevState.selectedPhotos.includes(photoId)
          ? prevState.selectedPhotos.filter(function (id) { return id !== photoId; })
          : prevState.selectedPhotos.concat(photoId),
      };
    });
  }

  // Delete each selected photo sequentially, then remove them from local state
  handleDeletePhotos() {
    var self           = this;
    var toDelete       = this.state.selectedPhotos.slice();
    var origin         = getLocationOrigin();

    self.setState({ deletingPhotos: true, deleteError: null });

    // Fire all deletes in parallel
    var requests = toDelete.map(function (photoId) {
      return fetch(origin + "/gallery/delete_photo/", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ photo_id: photoId }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then(function (data) {
          if (!data.success) throw new Error(data.message || "Delete failed");
          return photoId; // resolve with the id that succeeded
        });
    });

    Promise.all(requests)
      .then(function (deletedIds) {
        // Remove successfully deleted photos from local album state
        self.setState(function (prevState) {
          var remainingPhotos = prevState.album.photos.filter(function (photo) {
            return deletedIds.indexOf(photo.id) === -1;
          });
          return {
            album:            Object.assign({}, prevState.album, { photos: remainingPhotos }),
            selectedPhotos:   [],
            showDeleteDialog: false,
            deletingPhotos:   false,
          };
        });
      })
      .catch(function (err) {
        console.error("handleDeletePhotos error:", err);
        self.setState({
          deletingPhotos:   false,
          showDeleteDialog: false,
          deleteError:      "Some photos could not be deleted. Please try again.",
        });
      });
  }

  handleDeleteAlbum() {
    var self    = this;
    var albumId = this.props.match.params.albumId;

    self.setState({ deletingAlbum: true });

    fetch(getLocationOrigin() + "/tournament/delete_albums/", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ album_id: albumId }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to delete album (HTTP " + response.status + ")");
        return response.json();
      })
      .then(function (data) {
        if (!data.success) throw new Error("API returned success: false");
        self.setState({ showDeleteAlbumDialog: false, deletingAlbum: false });
        self.props.history.push("/crud/gallery");
      })
      .catch(function (err) {
        console.error("handleDeleteAlbum error:", err);
        self.setState({ showDeleteAlbumDialog: false, deletingAlbum: false });
      });
  }

  handleDownloadPhotos() {
    var self           = this;
    var selectedPhotos = this.state.selectedPhotos;
    var album          = this.state.album;

    if (!selectedPhotos.length || !album) return;

    this.setState({ downloading: true });

    var completed = 0;
    var total     = selectedPhotos.length;

    selectedPhotos.forEach(function (photoId, index) {
      var photo = album.photos.find(function (p) { return p.id === photoId; });
      if (!photo) {
        completed++;
        if (completed === total) self.setState({ downloading: false });
        return;
      }

      setTimeout(function () {
        var urlParts = photo.image.split("?")[0].split("/");
        var filename = urlParts[urlParts.length - 1] || "photo-" + photoId + ".jpg";
        var proxyUrl =
          getLocationOrigin() + "/gallery/proxy_download/" +
          "?url=" + encodeURIComponent(photo.image) +
          "&filename=" + encodeURIComponent(filename);

        fetch(proxyUrl)
          .then(function (response) {
            if (!response.ok) throw new Error("Proxy fetch failed");
            return response.blob();
          })
          .then(function (blob) {
            var objectUrl = URL.createObjectURL(blob);
            var a         = document.createElement("a");
            a.href        = objectUrl;
            a.download    = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
          })
          .catch(function (err) {
            console.error("Failed to download photo " + photoId + ":", err);
          })
          .then(function () {
            completed++;
            if (completed === total) {
              self.setState({ downloading: false, selectedPhotos: [] });
            }
          });
      }, index * 800);
    });
  }

  render() {
    var self                 = this;
    var loading              = this.state.loading;
    var error                = this.state.error;
    var album                = this.state.album;
    var selectedPhotos       = this.state.selectedPhotos;
    var showDeleteDialog     = this.state.showDeleteDialog;
    var showDeleteAlbumDialog = this.state.showDeleteAlbumDialog;
    var downloading          = this.state.downloading;
    var deletingAlbum        = this.state.deletingAlbum;
    var deletingPhotos       = this.state.deletingPhotos;
    var deleteError          = this.state.deleteError;
    var lightboxIndex        = this.state.lightboxIndex;

    if (loading) {
      return (
        <div className="album-detail album-detail--centered">
          <p className="album-detail__status-text">Loading album...</p>
        </div>
      );
    }

    if (error || !album) {
      return (
        <div className="album-detail album-detail--centered">
          <p className="album-detail__status-text album-detail__status-text--error">
            {error || "Album not found."}
          </p>
          <Link to="/crud/gallery" className="album-detail__back-link" style={{ marginTop: 12 }}>
            <ArrowLeft /> Back to Gallery
          </Link>
        </div>
      );
    }

    var tournament      = album.tournament || {};
    var displayName     = album.name && album.name !== "undefined" ? album.name : tournament.name || "Untitled Album";
    var displayDescription = album.description || tournament.name || "";
    var displayLocation = tournament.location || album.location || "";
    var displayVenue    = tournament.venue || "";
    var displayDate     = tournament.date || album.date_of_organized || "";
    var photos          = album.photos || [];

    return (
      <div className="album-detail">

        <div className="album-detail__header">
          <div className="album-detail__header-left">
            <Link to="/crud/gallery" className="album-detail__back-link">
              <ArrowLeft /> Back
            </Link>
            <div>
              <h1 className="album-detail__title">{displayName}</h1>
              {displayDescription ? <p className="album-detail__description">{displayDescription}</p> : null}
              <div className="album-detail__meta">
                {displayLocation ? <div className="album-detail__meta-item"><MapPin /><span>{displayLocation}</span></div> : null}
                {displayVenue    ? <div className="album-detail__meta-item"><Trophy /><span>{displayVenue}</span></div>    : null}
                {displayDate     ? <div className="album-detail__meta-item"><Calendar /><span>{displayDate}</span></div>   : null}
                <span className="album-detail__photo-count">{photos.length} Photos</span>
              </div>
            </div>
          </div>

          <div className="album-detail__toolbar">
            <Link to={"/crud/gallery/update/photos/" + this.props.match.params.albumId}>
              <ShadcnButton style={{ boxShadow: "none", border: "1px solid #e2e8f0" }}>
                <Plus /> Add Photos
              </ShadcnButton>
            </Link>
            <ShadcnButton
              style={{ boxShadow: "none", border: "1px solid #e2e8f0" }}
              variant="destructive"
              onClick={function () { self.setState({ showDeleteAlbumDialog: true }); }}
            >
              <Trash2 /> Delete Album
            </ShadcnButton>
          </div>
        </div>


        {deleteError && (
          <div style={{
            margin: "0 0 16px", padding: "10px 14px", borderRadius: "8px",
            background: "#fef2f2", border: "1px solid #fecaca",
            color: "#b91c1c", fontSize: "13px", display: "flex",
            alignItems: "center", justifyContent: "space-between",
          }}>
            <span>{deleteError}</span>
            <button
              onClick={function () { self.setState({ deleteError: null }); }}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#b91c1c", padding: "0 0 0 12px", fontSize: "16px" }}
            >
              &times;
            </button>
          </div>
        )}

        {selectedPhotos.length > 0 && (
          <div className="album-detail__selection-bar">
            <span className="album-detail__selection-label">
              {selectedPhotos.length} photo(s) selected
            </span>
            <div className="album-detail__selection-actions">
              <ShadcnButton variant="outline" disabled={downloading} onClick={self.handleDownloadPhotos}>
                <Download />
                {downloading ? "Downloading..." : "Download"}
              </ShadcnButton>
              <ShadcnButton
                variant="destructive"
                onClick={function () { self.setState({ showDeleteDialog: true }); }}
              >
                <Trash2 color="#fff" /> Delete
              </ShadcnButton>
              <ShadcnButton
                variant="secondary"
                onClick={function () { self.setState({ selectedPhotos: [] }); }}
              >
                Cancel
              </ShadcnButton>
            </div>
          </div>
        )}

        {photos.length === 0 ? (
          <p className="album-detail__status-text">No photos in this album yet.</p>
        ) : (
          <div className="album-detail__grid">
            {photos.map(function (photo, index) {
              var isSelected = selectedPhotos.includes(photo.id);
              return (
                <div
                  key={photo.id}
                  className={"album-detail__photo" + (isSelected ? " album-detail__photo--selected" : "")}
                  onClick={function () { self.openLightbox(index); }}
                >
                  <img src={getCDNUrl(photo.image)} alt={"Photo " + photo.id} />
                  <div className="album-detail__photo-overlay" />
                  
                  <div 
                    className={"album-detail__photo-select-btn" + (isSelected ? " album-detail__photo-select-btn--active" : "")}
                    onClick={function (e) {
                      e.stopPropagation();
                      self.togglePhotoSelection(photo.id);
                    }}
                    title="Select Photo"
                  >
                    <CheckIcon />
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <ConfirmModal
          open={showDeleteDialog}
          title="Delete Selected Photos?"
          confirmLabel={deletingPhotos ? "Deleting..." : "Delete"}
          loading={deletingPhotos}
          onCancel={function () {
            if (!deletingPhotos) self.setState({ showDeleteDialog: false });
          }}
          onConfirm={self.handleDeletePhotos}
        >
          Are you sure you want to delete {selectedPhotos.length} photo(s)? This action cannot be undone.
        </ConfirmModal>

        <ConfirmModal
          open={showDeleteAlbumDialog}
          title="Delete Album?"
          confirmLabel={deletingAlbum ? "Deleting..." : "Delete Album"}
          loading={deletingAlbum}
          onCancel={function () {
            if (!deletingAlbum) self.setState({ showDeleteAlbumDialog: false });
          }}
          onConfirm={self.handleDeleteAlbum}
        >
          Are you sure you want to delete this entire album including all {photos.length} photos? This action cannot be undone.
        </ConfirmModal>

        <Lightbox 
          open={lightboxIndex !== null}
          photos={photos}
          currentIndex={lightboxIndex}
          onClose={this.closeLightbox}
          onPrev={this.handlePrevLightbox}
          onNext={this.handleNextLightbox}
        />

      </div>
    );
  }
}

export default withRouter(AlbumDetail);


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/gallery/viewGalleryItem/index.js